import { createSlice } from "@reduxjs/toolkit";
import { RequestStatus } from "../../../model/ServiceRequestStatus.model";
import { postAgentMessage } from "../../../services/SPAAdmin/CampaignAgent.api";

export interface CampaignAgentState {
    threadId: string|null;
    content: {role: 'user'|'system', message: string}[];
    status: RequestStatus;
    selectedWorkflowId?: string;
}

const initialState: CampaignAgentState = {
    threadId: null,
    content: [],
    status: RequestStatus.idle
};

export const CampaignAgentSlice = createSlice({
    name: 'CampaignAgentSlice',
    initialState,
    reducers: {
        setCampaignWorkflowId: (state, action) => {
            state.selectedWorkflowId = action.payload;
        }
    },
    extraReducers(builder) {
        builder
            .addCase(postAgentMessage.pending, (state) => {
                state.status = RequestStatus.loading;
            })
            .addCase(postAgentMessage.fulfilled, (state, action) => { 
                state.status = RequestStatus.succeeded;
                state.threadId = action.payload.threadId
                state.content.push({
                    role: 'system',
                    message: action.payload.response
                });
            })
            .addCase(postAgentMessage.rejected, (state, action) => {
                state.status = RequestStatus.failed;
                console.error("Error in CampaignAgent postAgentMessage:", action.error.message);
            })
    }
});

export const { setCampaignWorkflowId } = CampaignAgentSlice.actions;

export const CampaignAgentReducer = CampaignAgentSlice.reducer